import { RootState } from '@/store';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GleapManager } from './gleapManager';
import { isUserAuthenticated } from '@/core/apiConfig';
import { TrackingManager } from './trackingManager';
import { isMobile } from '@/utils';

export const useGleap = () => {
  const user = useSelector((store: RootState) => store.user);
  const org = useSelector((store: RootState) => store.org);
  const [userIdentified, setUserIdentified] = useState(false);
  const [leadIdentified, setLeadIdentified] = useState(false);

  useEffect(() => {
    // Skip Gleap initialization on mobile devices
    if (isMobile()) {
      return;
    }
    GleapManager.init();
  }, []);

  useEffect(() => {
    // Skip Gleap on mobile devices
    if (isMobile()) {
      return;
    }

    const isAuthenticated = isUserAuthenticated();

    if (
      isAuthenticated &&
      !userIdentified &&
      user?.userId &&
      user?.email &&
      user?.displayName &&
      org?.name
    ) {
      GleapManager.identifyUser({
        userId: user.userId,
        displayName: user.displayName,
        email: user.email,
        org: org.name,
        permission: user.permission,
        phoneNumber: user.phoneNumber,
        title: user.title,
        role: user.role,
      });
      // Load user stats once per session and push to Mixpanel/Gleap
      TrackingManager.loadUserStatsOnce();
      setUserIdentified(true);
      setLeadIdentified(false);
    }
  }, [user, org, userIdentified]);

  useEffect(() => {
    // Skip Gleap on mobile devices
    if (isMobile()) {
      return;
    }

    const isAuthenticated = isUserAuthenticated();

    if (!isAuthenticated && !leadIdentified && !userIdentified) {
      GleapManager.identifyLead();
      setLeadIdentified(true);
    }
  }, [leadIdentified, userIdentified]);

  return {};
};
